<template>
  <v-list-item
    :to="{ name: toName }"
    color="primary"
    rounded="shaped"
    link
    class="d-flex justify-center"
  >
    <div class="d-flex flex-column align-center text-center">
      <v-img
        :src="imgSrc"
        height="32"
        width="32"
        contain
        class="mb-2"
      />

      <span class="text-body-2">
        {{ titleContent }}
      </span>
    </div>
  </v-list-item>
</template>

<script>
export default {
  name: 'MainMenuItem',
  props: {
    toName: {
      type: String,
      required: true
    },
    imgSrc: {
      type: String,
      required: true
    },
    titleContent: {
      type: String,
      required: true
    }
  }
}
</script>
